import RichText from 'components/shared/richtext';
import classNames from 'classnames';
import React from 'react';
import styles from './titleAndText.module.scss';
import Button from '../../shared/button';

const TitleAndText = ({ data, locale }) => {
  const { title, underlyingText, button } = data;

  return (
    <section id="sectionTitleAndText">
      <div className={styles.titleAndTextWrapper}>
        <h2 className={styles.title}>{title}</h2>
        {underlyingText?.json ? (
          <RichText
            className={styles.underlyingText}
            text={underlyingText.json}
            isPrivacyPage={data?.name === 'Privacy & Cookie Statement'}
          />
        ) : null}
        {button && (
          <Button
            className={classNames(styles.titleAndTextButton)}
            locale={locale}
            button={button}
          />
        )}
      </div>
    </section>
  );
};

export default TitleAndText;
